import { queryOptions } from "@tanstack/react-query";
import {
  fetchCampaignNegatives,
  fetchCampaignSearchTerms,
  fetchCampaignTargets,
} from "@/lib/campaign-api";
import type { ReportingTimeZone } from "@/lib/reporting-time-zone";
import { type ReportingPeriod, resolveReportingPeriod } from "@/stores/reporting-period";

export function campaignTargetsQuery(
  campaignId: string,
  range: ReportingPeriod,
  timeZone: ReportingTimeZone,
) {
  const dates = resolveReportingPeriod(range, new Date(), timeZone);
  return queryOptions({
    // Under the ["campaign", id] prefix so tag saves in the ad-group tables refresh this list too.
    queryKey: ["campaign", campaignId, "targets", dates.startDate, dates.endDate, timeZone],
    queryFn: ({ signal }) =>
      fetchCampaignTargets(campaignId, { type: "custom", ...dates }, timeZone, signal),
    staleTime: 30000,
  });
}

export function campaignSearchTermsQuery(
  campaignId: string,
  range: ReportingPeriod,
  timeZone: ReportingTimeZone,
) {
  const dates = resolveReportingPeriod(range, new Date(), timeZone);
  return queryOptions({
    queryKey: ["campaign", campaignId, "search-terms", dates.startDate, dates.endDate, timeZone],
    queryFn: ({ signal }) =>
      fetchCampaignSearchTerms(campaignId, { type: "custom", ...dates }, timeZone, signal),
    staleTime: 30000,
  });
}

export function campaignNegativesQuery(campaignId: string) {
  return queryOptions({
    queryKey: ["campaign", campaignId, "negatives"],
    queryFn: ({ signal }) => fetchCampaignNegatives(campaignId, signal),
    staleTime: 30000,
  });
}
